// extracted by mini-css-extract-plugin
export default {"leftArrowWrapperStyle":"styles_leftArrowWrapperStyle__qO9mB","arrowBtnStyle":"styles_arrowBtnStyle__MS3L2","backArrowStyle":"styles_backArrowStyle__vylea"};